import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import { actionCreators } from "../../../store/integration/SpoStore";
import { SourceType } from "../../../store/ExternalEpmConnectStore";
import { IConnectionsState } from "../../../store/integration/common";
import SpoConnectionEdit from "../../integration/Spo/SpoConnectionEdit";
import BasicAuthConnectionCard from './BasicAuthConnectionCard';

type OwnProps = {}
type StateProps = { connections: IConnectionsState };
type Props = StateProps & OwnProps & typeof actionCreators;
const SpoConnectionCard = (props: Props) => <BasicAuthConnectionCard
    system={SourceType.Spo}
    connections={props.connections.data}
    renderConnect={(onCreated, onDismiss) => <SpoConnectionEdit onDismiss={onDismiss}
        onCreated={(connectionId: string) => {
            props.loadConnections();
            onCreated(connectionId);
        }} />}
/>;
function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    return { connections: state.spo.connections }
}
export default connect(mapStateToProps, actionCreators)(SpoConnectionCard);